export enum AnalysisResult {
    UNKNOWN="0",//TODO: Manoj change type from string to numbers
    OK="1",
    CAUTION="2",
    WARNING="3"
}